"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _UGAVMSQJcjs = require('../__chunks/UGAVMSQJ.cjs');
require('../__chunks/GDZQUFNP.cjs');
require('../__chunks/VC22SYOD.cjs');
require('../__chunks/I4CBIWTX.cjs');
require('../__chunks/WMTGHDLE.cjs');


var _4TRESXTOcjs = require('../__chunks/4TRESXTO.cjs');

// src/toolbar/toolbar-store.ts
function createToolbarStore(props = {}) {
  var _a;
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  return _UGAVMSQJcjs.createCompositeStore.call(void 0, {
    ...props,
    orientation: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "horizontal"
    ),
    focusLoop: _4TRESXTOcjs.defaultValue.call(void 0, props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  });
}


exports.createToolbarStore = createToolbarStore;
